import { withNamespaces } from 'react-i18next';

import {
    getMessageFromParty,
    getMessageSubject,
    getPartyInitials,
} from '../../../helpers';

const MessageHeader = ({
    t,
    message,
}) => {
    const from = getMessageFromParty(message);
    const subject = getMessageSubject(message);
    const initials = getPartyInitials(from.name, from.email);

    return (
        <div className="mailbox-message-detail__header">
            <div className="d-flex align-items-center mb-3">
                <div className="mailbox-message-detail__avatar me-3">
                    {initials}
                </div>
                <div>
                    <div className="fw-semibold">
                        {from.name || from.display || t('Unknown sender')}
                    </div>
                    {from.email ? (
                        <div className="text-muted small">
                            {from.email}
                        </div>
                    ) : null}
                </div>
            </div>

            <h4 className="mailbox-message-detail__subject mb-0">
                {subject || t('(No subject)')}
            </h4>
        </div>
    );
};

export default withNamespaces()(MessageHeader);
